<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { Finanzmanager } from "@/application/router/types/types";
import BankingWrapper from '@/application/layouts/ContentWrapper/BankingWrapper.vue';
import { throwableCall } from '@/api/lib/integration.ts';
import { deleteBanksApiUser } from '@/api/banking/banksApi.ts';
import { useBankingStore } from '@/banking/store/bankingStore.ts';
import { captureException } from '@sentry/vue';
import { useTagManager } from '@demv_systems/feu-tag-manager';
import { TrackEventCategory } from '@/application/utils/tracking/events';
import AppButton from '@/application/components/ui/AppButton.vue';
import ConfirmModal from '@/application/components/ConfirmModal.vue';
import { useBaseDataStore } from '@/user/store/baseDataStore.ts';

const router = useRouter();
const bankingStore = useBankingStore();
const { duzen } = useBaseDataStore();

const showDeleteConfirm = ref(false);

async function onOpenRegprotect(e: CustomEvent) {
  const { sessionLink } = e.detail;
  await router.push({ path: '/banking/regprotect', query: { sessionLink } });
}

async function onGoBack(event: CustomEvent) {
  event.preventDefault();
  await router.push('/banking');
}

async function onDeleteUser() {
  try {
    await throwableCall(deleteBanksApiUser())
    useTagManager().push({ event: TrackEventCategory.BANKS_API, action: 'deleteUser' });
  } catch (err) {
    captureException(err);
  } finally {
    bankingStore.$reset();
    await router.push({ name: Finanzmanager.VERTRAEGE });
  }
}
</script>

<template>
  <BankingWrapper v-slot="{ token, onEmitError }">
    <!-- eslint-disable vue/v-on-event-hyphenation -->
    <!-- eslint-disable vue/attribute-hyphenation -->
    <ba-bam-dashboard
      :token="token"
      @openRegprotect="onOpenRegprotect"
      @goBack="onGoBack"
      @emitError="(e) => onEmitError(e, 'ba-bam-dashboard')"
    >
      <div slot="custom-element" class="flex justify-center">
        <AppButton
          type="danger"
          plain
          class="w-full sm:max-w-[480px]"
          @click="showDeleteConfirm = true"
        >
          Multibanking-Konto löschen
        </AppButton>
      </div>
    </ba-bam-dashboard>
  </BankingWrapper>

  <ConfirmModal
    v-model:show="showDeleteConfirm"
    title="Multibanking-Konto löschen"
    variant="danger"
    icon="trash"
    confirm-label="Löschen"
    :confirm="onDeleteUser"
  >
    Alle verknüpften Bankzugänge werden getrennt. Kontostände, Umsätze, Depots und die Budgetanalyse
    sind danach im Finanzmanager nicht mehr verfügbar. Um das Banking wieder zu nutzen,
    {{ duzen('musst du deine Bankzugänge neu verbinden.', 'müssen Sie Ihre Bankzugänge neu verbinden.') }}
  </ConfirmModal>
</template>
